import { isAxiosError } from "axios";
import { axios } from "../../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../../config/toast";
import { Link } from "react-router-dom";

const coloresEstados = [
  { id: 1, color: "btn-success" },
  { id: 2, color: "btn-primary" },
  { id: 3, color: "btn-danger" },
];

export const getColorEstado = (id) => {
  let rta = coloresEstados.filter((col) => {
    if (col.id === id) {
      return col.color;
    }
  });
  return rta[0].color;
};

export const getPodador = async (podador, setPodador, id) => {
  setPodador({ ...podador, loading: true });
  let response = await axios().get("podador/" + id);

  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setPodador({ ...podador, data: data, loading: false });
    }

    if (!data && error) {
      setPodador({ ...podador, error: error, loading: false });
      toast.error(error, toastOptions);
    }
  } else {
    setPodador({ ...podador, loading: false, error: "Hubo un error inesperado" });
  }
};

export const setPodador = async (datos, rta, setRta, id) => {
  setRta({ ...rta, loading: true });
  let response = await axios().patch("podador/" + id, datos);

  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, data: data, loading: false });
      toast.success("Podador actualizado", toastOptions);
    }

    if (error && !data) {
      setRta({ ...rta, error: error, loading: false });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const setEstado = async (estado, sta, setSta, id) => {
  setSta({ ...sta, loading: true });
  let response = await axios().patch("podador/estado/" + id, { estado_podador_id: estado.estado });
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setSta({ ...sta, data: data, loading: false });
      toast.success(data, toastOptions);
    }

    if (error && !data) {
      setSta({ ...sta, error: error, loading: false });
      toast.error(error, toastOptions);
    }
  } else {
    setSta({ ...sta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const crearPodador = async (datos, rta, setRta, reset) => {
  setRta({ ...rta, loading: true });
  let response = await axios().post("podador", datos);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, loading: false, data: data });
      toast.success("Podador creado", toastOptions);
      reset();
    }

    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const crearObservacion = async (datos, rta, setRta, reset, id) => {
  setRta({ ...rta, loading: true });
  let response = await axios().patch("/podador/observacion/" + id, datos);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, loading: false, data: data });
      reset();
      toast.success("Observación creada", toastOptions);
      reset;
    }

    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const eliminarObservacion = async (rta, setRta, id) => {
  setRta({ ...rta, loading: true });
  let response = await axios().delete("/observacion/" + id);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setRta({ ...rta, loading: false, data: data });
      toast.success("Observación eliminada", toastOptions);
    }

    if (error && !data) {
      setRta({ ...rta, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setRta({ ...rta, loading: false, error: "Hubo un error inesperado" });
  }
};

export const dataTable = (data, state, open, setOpen, setDestroy) => {
  const columns = [
    { field: "id", headerName: "#", flex: 0.5, minWidth: 50 },
    {
      field: "razon",
      headerName: "Razón",
      minWidth: 250,
      flex: 1,
    },
    {
      field: "fecha",
      headerName: "Fecha",
      minWidth: 50,
      flex: 2,
    },
    {
      field: "boton",
      headerName: "Ver mas Info",
      renderCell: (p) => {
        return (
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              setOpen(true);
              setDestroy(p.row);
            }}
          >
            Eliminar
          </button>
        );
      },
      minWidth: 120,
      flex: 1,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      razon: d.razon,
      fecha: d.fecha,
      boton: d.id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.razon?.toLowerCase().includes(value) ||
      d.fecha?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
